import React, { useEffect } from "react";
import {
    Container,
    Row,
    Col,
    Card,
    Table,
    Badge,
} from "react-bootstrap";
import { getTeam } from "../../store/slices/user"
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";


export default function UserMyteam() {

    const dispatch = useDispatch();

    const { team, } = useSelector(
        (state) => state.user
    );

    useEffect(() => {
        dispatch(getTeam());
    }, [dispatch]);


    const teamLevels = team?.levels
        ? Object.entries(team.levels).map(
            ([level, members]) => ({
                level: `Level ${level}`,
                members,
            })
        )
        : [];


    const totalMembers =
        team?.totalTeam || 0;

    const activeMembers = teamLevels.reduce(
        (total, level) =>
            total +
            level.members.filter(
                (member) => member.isActive
            ).length,
        0
    );
    const inactiveMembers =
        totalMembers - activeMembers;

    return (
        <>

            <div className="breadcrumb-bar mb-2 mx-1">
                <div className="container-fluid">
                    <div className="d-flex flex-row flex-md-row align-items-md-center justify-content-between gap-2 py-2">

                        <div className="breadcrumb-left d-flex align-items-center flex-wrap">
                            <Link to="/user/home" className="breadcrumb-link active my-2">
                                Home
                            </Link>

                            <span className="breadcrumb-separator mx-2">
                                <i className="bi bi-chevron-right"></i>
                            </span>

                            <span
                                className="breadcrumb-link inactive"
                            // onClick={() => navigate("/user/myteam")}
                            >
                                Myteam
                            </span>
                        </div>

                        {/* <button
                            className="add-outlet-btn"
                            onClick={() => navigate("/admin/projects")}
                        >
                            <i className="bi bi-list-ul me-2"></i>
                            Projectlist
                        </button> */}

                    </div>
                </div>
            </div>


            <div className="team-page-wrapper">

                <Container fluid>

                    <div className="global-header-card">

                        <div>

                            <h2 className="team-title">
                                Team Members
                            </h2>

                            <p className="team-subtitle">
                                Manage and monitor your complete referral network
                            </p>

                        </div>

                        <div className="team-badge-box">

                            <Badge className="team-badge">
                                {Object.keys(team?.levels || {}).length} Levels
                            </Badge>
                        </div>

                    </div>


                    {/* table */}

                    <Card className="team-table-card mb-5">

                        <div className="table-responsive">

                            <Table hover className="team-table align-middle">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Name</th>
                                        <th>Referral Code</th>
                                        <th>Sponsor Name</th>

                                        <th>LEVEL</th>
                                        <th>STATUS</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {teamLevels.map((levelData) => (
                                        <React.Fragment key={levelData.level}>
                                            <tr className="level-row">
                                                <td colSpan="7">
                                                    <div className="level-title">
                                                        <span className="level-dot"></span>
                                                        {levelData.level}
                                                    </div>
                                                </td>
                                            </tr>

                                            {levelData.members.map(
                                                (member, index) => (
                                                    <tr key={member.userId}>
                                                        <td>{index + 1}</td>

                                                        <td>{member.name}</td>
                                                        <td>
                                                            {member.referralCode}
                                                        </td>


                                                        <td>
                                                            {member.parent?.name}
                                                        </td>


                                                        <td>
                                                            Level {member.level}
                                                        </td>

                                                        <td>
                                                            <Badge
                                                                bg={
                                                                    member.isActive
                                                                        ? "success"
                                                                        : "danger"
                                                                }
                                                            >
                                                                {member.isActive
                                                                    ? "Active"
                                                                    : "Inactive"}
                                                            </Badge>
                                                        </td>
                                                    </tr>
                                                )
                                            )}
                                        </React.Fragment>
                                    ))}

                                </tbody>

                            </Table>

                        </div>

                    </Card>

                </Container>

            </div>
        </>
    );
};